import React, { useMemo } from 'react';

import { getTableCellPlainTextStyle } from '../utils/dataUtils/cell/tableCellPlainTextStyleUtils';

type Props = {
    plainText: string;
    style: React.CSSProperties;
    textStyle?: string[];
};

const TableCellPlainTextRenderer: React.FC<Props> = ({ plainText, style, textStyle }) => {
    const plainTextSpanCssStyle = useMemo<React.CSSProperties>(
        () => getTableCellPlainTextStyle(textStyle),
        [textStyle],
    );

    return (
        <p className="TableCellPlainTextRenderer" style={style}>
            <span style={plainTextSpanCssStyle}>{plainText}</span>
        </p>
    );
};

export default TableCellPlainTextRenderer;
